class Tab{
    constructor(box) {
        this.$box = $(box);
        this.$btn = this.$box.find('.tab__btn');
        this.$con = this.$box.find('.tab__con');

        if( this.$btn.length ) this.init();
    }

    init() {
        if( !this.$box.find('.active').length ) return false;

        let tabID = this.$box.find('.active').data().tab;
        this.$con.each( (idx,elem) => $(elem).data().tabCon == tabID ? $(elem).show() : '' );

        this.bindEvent();
    }

    action(t) {
        if( $(t).hasClass('disabled') ) return false;
        let tabID = $(t).data().tab;

        this.$btn.removeClass('active');
        $(t).addClass('active');
        this.$con.hide();
        this.$con.each( (idx,elem) => $(elem).data().tabCon == tabID ? $(elem).show() : '' );
    }

    disable() {
        this.$btn.removeClass('active').addClass('disabled');
    }

    bindEvent() {
        this.$btn.not('.disabled').on('click', (e)=>{
            this.action(e.target)
        });
    }
}

export default Tab;


// WEBPACK FOOTER //
// ./src/js/components/tab.js